import React, { useState } from 'react';
import ClientRecordBillingContactDetails from './ClientRecordBillingContactDetails';
import EditClientRecordBillingContactDetails from './EditClientRecordBillingContactDetails';

export type ClientRecordBillingContactOwnProps = {
    clientRecordId: string;
};

export type ClientRecordBillingContactProps = ClientRecordBillingContactOwnProps;

const ClientRecordBillingContact: React.FC<ClientRecordBillingContactProps> = ({ clientRecordId }) => {
    const [isEditing, setIsEditing] = useState(false);

    return isEditing ? (
        <EditClientRecordBillingContactDetails
            clientRecordId={clientRecordId}
            onCancel={() => setIsEditing(false)}
            onSave={() => {
                setIsEditing(false);
            }}
        />
    ) : (
        <ClientRecordBillingContactDetails onEdit={() => setIsEditing(true)} clientRecordId={clientRecordId} />
    );
};

export default React.memo(ClientRecordBillingContact);
